import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { TmaisBadgeFormSchema } from '../schemas/form.schema'

interface UseUpdateTmaisBadgeProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

type UpdateVariables = {
  id: string
  form: TmaisBadgeFormSchema
}

export const useUpdateTmaisBadge = ({ onSuccess, onError }: UseUpdateTmaisBadgeProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateTmaisBadge'],
    mutationFn: async ({ id, form }: UpdateVariables) => {
      const payload = {
        display_name: form.display_name.trim(),
        background_color: form.background_color.toUpperCase(),
        text_color: form.text_color.toUpperCase(),
        icon: form.icon instanceof File ? form.icon : undefined
      }

      return privateAxios.putForm(`/tmais/badges/${id}`, { badge: payload })
    },
    onSuccess,
    onError,
  })
}